(function () {
  function bucketBadge(pct) {
    if (pct >= 50) return 50;
    if (pct >= 40) return 40;
    if (pct >= 30) return 30;
    if (pct >= 20) return 20;
    if (pct >= 10) return 10;
    return null;
  }

  function pickCompare(row, priceCents) {
    const regularCents = parseInt(row.dataset.regularCents || "0", 10) || 0;
    const compareCents = parseInt(row.dataset.compareCents || "0", 10) || 0;

    const regularText = row.dataset.regularPrice || "";
    const compareText = row.dataset.comparePrice || "";

    if (regularCents > priceCents && regularText) {
      return { cents: regularCents, text: regularText };
    }
    if (compareCents > priceCents && compareText) {
      return { cents: compareCents, text: compareText };
    }
    return { cents: 0, text: "" };
  }

  function updateCard(card, variantId) {
    const rows = [...card.querySelectorAll(".product-prices .price[data-variant-id]")];
    if (!rows.length) return;

    const row =
      rows.find((r) => r.dataset.variantId === String(variantId)) ||
      rows[0];

    const priceCents = parseInt(row.dataset.priceCents || "0", 10) || 0;
    const priceText = row.dataset.price || "";

    const currentEl = card.querySelector("[data-card-price-current]");
    const compareEl = card.querySelector("[data-card-price-compare]");
    const badgeWrap = card.querySelector("[data-card-promo-badge]");

    if (currentEl) currentEl.textContent = priceText;

    const picked = pickCompare(row, priceCents);

    // Compare / strikethrough
    if (compareEl) {
      if (picked.cents > priceCents && picked.text) {
        compareEl.textContent = picked.text;
        compareEl.style.display = "";
      } else {
        compareEl.textContent = "";
        compareEl.style.display = "none";
      }
    }

    // Badge
    if (badgeWrap) {
      const img = badgeWrap.querySelector("img");

      // No discount => hide
      if (!img || !(picked.cents > priceCents)) {
        if (img) {
          img.removeAttribute("src");
          img.alt = "";
        }
        badgeWrap.style.display = "none";
        return;
      }

      const discountPct = Math.floor(((picked.cents - priceCents) * 100) / picked.cents);
      const badgePct = bucketBadge(discountPct);

      if (!badgePct) {
        img.removeAttribute("src");
        img.alt = "";
        badgeWrap.style.display = "none";
        return;
      }

      // IMPORTANT: read attribute directly (works with data-badge-20)
      const url = badgeWrap.getAttribute("data-badge-" + badgePct);

      if (url) {
        img.src = url;
        img.alt = "-" + badgePct + "%";
        badgeWrap.style.display = "block"; // force visible
      } else {
        img.removeAttribute("src");
        img.alt = "";
        badgeWrap.style.display = "none";
      }
    }
  }

  function initCards() {
    document.querySelectorAll(".product__card").forEach((card) => {
      const active = card.querySelector(".product__card-color.active[data-variant-id]");
      const initialVariantId = active?.dataset.variantId;

      if (initialVariantId) updateCard(card, initialVariantId);

      card.querySelectorAll(".product__card-color[data-variant-id]").forEach((swatch) => {
        swatch.addEventListener("click", () => {
          card.querySelectorAll(".product__card-color.active").forEach((el) => el.classList.remove("active"));
          swatch.classList.add("active");
          updateCard(card, swatch.dataset.variantId);
        });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCards);
  } else {
    initCards();
  }
})();